<template>
  <span>
    <button type="button" class="button" @click="showingModal = true">
      <span class="icon"><i class="fa fa-plus"></i></span>
      <span>Add {{ contactType }}</span>
    </button>

    <modal
      :title="title"
      width="800px"
      @close="showingModal = false"
      v-if="showingModal"
      full-height
    >
      <div class="field">
        <div class="label">Name</div>
        <div class="control">
          <multiselect
            v-model="selectedCompany"
            :options="availableCompanies"
            :searchable="true"
            label="name"
            track-by="id"
            placeholder="Start typing to search companies"
            @search-change="fetchAvailableCompanies"
            @select="getDetails"
            @remove="companyDetails = {}"
          >
            <template slot="noResult"
              >No companies found.
              <a
                :href="
                  maxxIntranetDomain + '/membership/CompanyFormPrivate/edit'
                "
                target="_blank"
                >Click here to add a company to the database.</a
              ></template
            >
            <template slot="noOptions"
              ><div class="help">
                Can't find the company?
                <a
                  :href="
                    maxxIntranetDomain + '/membership/CompanyFormPrivate/edit'
                  "
                  target="_blank"
                  >Click here to add it to the database.</a
                >
              </div></template
            >
          </multiselect>
          <div class="help">
            Can't find the company?
            <a
              :href="maxxIntranetDomain + '/membership/CompanyFormPrivate/edit'"
              target="_blank"
              >Click here to add it to the database.</a
            >
          </div>
        </div>
      </div>

      <b-notification
        v-if="noMaxxUser"
        type="is-danger"
        has-icon
        :closable="false"
        class="is-small"
        role="alert"
      >
        You are not logged in as a MatrixMaxx user. Please login to fix this
        problem.
      </b-notification>
      <h2 v-if="companyDetails.name" class="title is-3">
        {{ companyDetails.name }}
      </h2>
      <div class="columns" v-show="companyDetails.name">
        <div class="column is-3">
          <div class="field">
            <label class="image is-150x150 show-icon-hover">
              <span class="icon icon-right is-medium"
                ><i class="fas fa-pen-square fa-2x"></i
              ></span>
              <img
                :src="
                  fixHttpProtocol(companyDetails.logo_path) ||
                    '/static/150x150.png'
                "
                style="display: block"
                v-if="companyDetails"
              />
              <input type="file" style="display: none" />
            </label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <div class="label">Description</div>
            <textarea
              class="textarea"
              v-model="companyDetails.description"
            ></textarea>
          </div>
        </div>
      </div>

      <div slot="footer">
        <button
          class="button is-success"
          :class="{ 'is-loading': loading }"
          @click="saveSuite"
        >
          Add {{ contactType }}
        </button>
        <button class="button" @click="close">Cancel</button>
      </div>
    </modal>
  </span>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Modal from './Modal';
import { db } from '@/services/firebase';
import { fixHttpProtocol } from '@/services/utils';
import MaxxAPI from '@/services/maxxapi';

export default {
  data() {
    return {
      showingModal: false,
      loading: false,
      availableCompanies: [], // list of available companies from Maxx
      companyContacts: [], // list of contacts for the selected company
      selectedCompany: {
        id: null,
        name: null
      },
      companyDetails: {
        id: null,
        name: null,
        logo_path: null,
        description: null
      },
      noMaxxUser: false,
      maxxIntranetDomain: process.env.MAXX_INTRANET_DOMAIN
    };
  },
  model: {
    prop: 'company',
    event: 'change'
  },
  props: {
    contactType: {
      type: String
    },
    meetingId: {
      type: String
    }
  },
  computed: {
    isEdit() {
      return !this.isNewCompany;
    },
    title() {
      return `Add ${this.contactType}`;
    },
    suiteOrTeam() {
      if (this.typeString === 'Retailer') return 'Team';
      return 'Suite';
    }
  },
  methods: {
    fixHttpProtocol,
    close() {
      this.showingModal = false;
      this.selectedCompany = {
        id: null,
        name: null
      };
      this.companyDetails = {
        id: null,
        name: null,
        logo_path: null,
        description: null
      };
      this.availableCompanies = [];
      this.loading = false;
    },
    getDetails(selectedCompany) {
      this.fetchCompanyDetails(selectedCompany.id);
    },
    fetchAvailableCompanies(query) {
      if (query.length >= 3) {
        MaxxAPI.searchCompanies(query).then(response => {
          this.availableCompanies = response;
        });
      }
    },
    fetchCompanyDetails(companyId) {
      this.loading = true;
      MaxxAPI.getCompany(companyId).then(response => {
        if (response.error && response.error === 'No user') {
          this.loading = false;
          this.noMaxxUser = true;
        } else {
          this.noMaxxUser = false;
          this.companyDetails.id = response.id;
          this.companyDetails.name = response.Name;
          this.companyDetails.logo_path = response.CompanyLogo;
          this.companyDetails.description = response.CompanyDescription;
        }
        this.loading = false;
      });
    },
    saveSuite() {
      this.loading = true;

      const suiteToSave = {
        name: this.companyDetails.name,
        description: this.companyDetails.description,
        logo_path: this.companyDetails.logo_path,
        type: this.contactType,
        appointment_slots: {},
        company: {
          maxxId: this.companyDetails.id,
          name: this.companyDetails.name,
          description: this.companyDetails.description,
          logo_path: this.companyDetails.logo_path
        }
      };
      if (!suiteToSave.name) {
        this.loading = false;
      } else {
        const suitesCollection = db
          .collection('meetings')
          .doc(this.meetingId)
          .collection('suites');

        suitesCollection.add(suiteToSave).then(docRef => {
          this.$emit('editSuite', docRef.id);
          this.close();
        });
      }
    }
  },
  components: {
    Multiselect,
    Modal
  }
};
</script>

<style scoped>
.show-icon-hover {
  position: relative;
  cursor: pointer;
}

span.icon-right {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  transition: opacity 0.2s linear;
}

.show-icon-hover:hover span.icon-right {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalAddSuite.vue